import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { GET_PROGRESS_RANKINGS, SHOW_PROGRESS_RANKINGS_SPINNER } from '../actions/getProgressRankings';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TBossRankingsClientState } from '../libs/store';

export default function progressRankings(
  state: Partial<TBossRankingsClientState> = {},
  action: TAction<any>
): Partial<TBossRankingsClientState> {
  switch (action.type) {
    case GET_PROGRESS_RANKINGS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SHOW_PROGRESS_RANKINGS_SPINNER: {
      return {
        ...state,
        uiLoading: action.payload
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default:
      return state;
  }
}
